export const websocketReducer = (state = {
    socket: null,
    status: 'CLOSED',
}, action) => {
    switch (action.type) {
        case 'WEBSOCKET_SET_CONNECT': {
            const { socket } = action.payload;
            return Object.assign(Object.assign({}, state), { socket: socket, status: 'OPENED' });
        }
        case 'WEBSOCKET_SET_STATUS': {
            const { status } = action.payload;
            return Object.assign(Object.assign({}, state), { status: status });
        }
        default:
            return state;
    }
};
export default websocketReducer;
